/** Badge component: a generic pill in one of the charter's extended-palette tones. */
import type { HTMLAttributes, ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'violet' | 'red' | 'green' | 'yellow' | 'blue';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  children: ReactNode;
}

/**
 * Render a generic pill badge in one of the charter's extended-palette tones.
 *
 * @param props - Span properties; unknown props are spread on the pill.
 * @returns The badge element.
 */
export function Badge({ tone = 'neutral', className, children, ...rest }: BadgeProps) {
  const classes = ['ui-badge', `ui-badge--${tone}`, className].filter(Boolean).join(' ');
  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}
